import React, { useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { FormGroup, Input } from "reactstrap";
import { Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./style.css";
import infoIcon from "../images/info.svg"


const SingleCheckPanel = ({
  label,
  options,
  input,
  meta: { touched, error },
}: any) => {
  const [selected, setSelected] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onChangeValues = () => {
    setSelected(!selected);
  };
  return (
    <div className="check CPS">
      <Form.Group className="check-panel-group">
        <FormControl required={label ? true : false} component="fieldset">
          <FormGroup className="form-group">
            <label>{label}</label>
            {options?.map((option: any, index: number) => (
              <FormGroup
                key={index}
                className={`${
                  input.value.indexOf(option.value) !== -1 ? "optChecked" : ""
                } check-panel`}
              >
                <label className="panel-box">
                  <Input
                    type="checkbox"
                    checked={input.value.indexOf(option.value) !== -1}
                    name={`${input.name}[${index}]`}
                    color="default"
                    onChange={(event: { target: { checked: any } }) => {
                      const newValue = [];
                      if (event.target.checked) {
                        newValue.push(option.value);
                      }
                      return input.onChange(newValue);
                    }}
                  />

                  <span> {option.label ? option.label : option.text} </span>
                </label>
                {option.text !== "Other" ? (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    rootClose
                    placement="bottom"
                    overlay={
                      <Popover id="popover-basic">
                        <Popover.Body>
                          {option?.questionOptionHelpText}
                        </Popover.Body>
                      </Popover>
                    }
                  >
                     <img src={infoIcon} alt="infoIcon" className="infoIcon"/>
                  </OverlayTrigger>
                ) : (
                  ""
                )}
              </FormGroup>
            ))}
          </FormGroup>
          {touched && <h6 className="danger">{error}</h6>}
        </FormControl>
      </Form.Group>
    </div>
  );
};
export default SingleCheckPanel;
